export { SEMRESATTRS_SERVICE_NAME } from '@opentelemetry/semantic-conventions';
export const OTEL_SERVICE_NAME = process.env.OTEL_SERVICE_NAME || 'glovo-o11y';
export const OTEL_COLLECTOR_URL = process.env.OTEL_COLLECTOR_URL;
export const CI_METRICS_OTEL_TOKEN = process.env.CI_METRICS_OTEL_TOKEN;
export const SEVERITY = {
    info: {
        severityNumber: 9,
        severityText: 'INFO',
    },
    error: {
        severityNumber: 17,
        severityText: 'ERROR',
    },
    warn: {
        severityNumber: 13,
        severityText: 'WARN',
    },
};
//# sourceMappingURL=constants.js.map